export default __webpack_public_path__ + "package.16285d07d272b7e484556f7a89fca755.png";